<template>
  <nav :class="'nav py-3 ' + (navSolid ? 'solid' : '')">
    <div class="container">
      <div class="row">
        <div class="col-4 d-none d-md-flex">
          <a class="nav-link" href="#photos">Photos</a>
          <a class="nav-link" href="#highlight">Highlight</a>
        </div>
        <div class="col-12 col-md-4 text-center color-white lbld">
          <div class="f-xlg">HomeForSale</div>
        </div>
        <div class="col-4 d-none d-md-flex justify-content-end">
          <a class="nav-link" href="#layout">Layout</a>
          <a class="nav-link" href="#contact">Contact</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  mounted() {
    $(window).scroll(() => {
      this.scrollCheck();
    });

    this.scrollCheck();
  },
  data() {
    return {
      navSolid: false,
    };
  },
  methods: {
    scrollCheck() {
      let scroll = $(window).scrollTop();

      this.navSolid = false;

      if (scroll > 50) {
        this.navSolid = true;
      }
    },
  },
};
</script>

<style>
.nav {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  position: fixed;
}
.nav.solid {
  background: rgb(62, 60, 64);
  background: linear-gradient(
    0deg,
    rgba(62, 60, 64, 0) 0%,
    rgba(27, 25, 28, 1) 125%
  );
}
.nav-link {
  color: #fff;
  padding: 10px 15px;
  margin: 0 5px;
  border-radius: 4px;
  font-weight: 500;
}
.nav-link:active,
.nav-link:focus {
  color: #fff;
}
.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}
</style>
